import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight } from 'lucide-react';
export function CornFrittersPage() {
  return <div className="min-h-screen bg-white" data-id="element-928">
      {/* Header */}
      <Header variant="solid" data-id="element-929" />

      {/* Hero Section */}
      <section className="relative py-20 px-8 mt-20" data-id="element-930">
        <div className="max-w-4xl mx-auto" data-id="element-931">
          {/* Breadcrumb */}
          <div className="text-sm text-neutral-500 mb-6" data-id="element-932">
            <a href="/blog" className="hover:text-brand-pink transition-colors" data-id="element-933">
              News & Events
            </a>
            <span className="mx-2" data-id="element-934">/</span>
            <span className="text-neutral-900" data-id="element-935">
              Craving our famous Corn Fritters?
            </span>
          </div>

          {/* Title */}
          <h1 className="font-heading text-4xl lg:text-5xl text-neutral-900 leading-tight mb-6" data-id="element-936">
            Craving our famous Corn Fritters?
          </h1>

          {/* Featured Image */}
          <div className="relative aspect-[16/9] overflow-hidden bg-gray-300 mb-12" data-id="element-937">
            <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Peterson-House-Restaurant-Image.jpg" alt="Famous Corn Fritters" className="w-full h-full object-cover" data-id="element-938" />
          </div>

          {/* Content */}
          <article className="max-w-none" data-id="element-939">
            <p className="text-neutral-600 text-lg leading-relaxed mb-8" data-id="element-940">
              Delicious and full of flavour, all round amazing, not to mention
              filling!
            </p>

            <p className="text-neutral-600 text-lg leading-relaxed mb-8" data-id="element-941">
              These corn fritters have been our most popular breakfast item from
              the second they were put on the menu. Some people don't even need
              to look at the menu, whilst others travel back just to taste our
              delicious golden corn fritters again. How amazing is that!
            </p>

            {/* Fun Fact Section */}
            <div className="bg-brand-pink/10 border-l-4 border-brand-pink p-8 my-8" data-id="element-942">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-943">
                Fun Fact!
              </h3>
              <p className="text-neutral-700 text-lg leading-relaxed mb-4" data-id="element-944">
                Did you know that our recipe is from a former employee's mum!
                When creating the new menu, the young chef suggested his mums
                corn fritters. After our chefs put their spin on the recipe
                there was no turning back.
              </p>
              <p className="text-neutral-700 text-lg leading-relaxed" data-id="element-945">
                Taking them off the menu was attempted ONCE, that only lasted a
                matter of weeks! After customers had some stern words 😉 they
                returned to the menu IMMEDIATELY!
              </p>
            </div>

            {/* The Dish */}
            <div className="mb-8" data-id="element-946">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-947">
                The Perfect Breakfast
              </h3>
              <p className="text-neutral-600 text-lg leading-relaxed mb-4" data-id="element-948">
                Our delectable corn fritters come in a half serve (one fritter)
                or full serve (two fritters) with caramelised balsamic, avocado
                salsa and crème fraiche!
              </p>
              <p className="text-neutral-600 text-lg leading-relaxed" data-id="element-949">
                Enjoy them on their own or add smoked salmon, bacon, mushrooms,
                or even a sneaky hash brown– whatever you want!
              </p>
            </div>

            {/* Pairing */}
            <div className="bg-neutral-50 p-8 my-8" data-id="element-950">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-951">
                Perfect Pairing
              </h3>
              <p className="text-neutral-700 text-lg leading-relaxed" data-id="element-952">
                Of course, our corn fritters pair perfectly with our Peterson
                House bubbles but especially with our previously featured Pink
                Blush Rose. The perfect balance of sweet and savoury to start
                your day here in the Hunter Valley.
              </p>
            </div>

            <p className="text-neutral-600 text-lg leading-relaxed mb-8" data-id="element-953">
              Our corn fritters are loved by all, as you can see in our photo
              that even our wildlife are excited to have a taste, giving our
              fritters their very own Disney princess moment.
            </p>

            {/* Dietary Information */}
            <div className="bg-brand-pink/10 border-l-4 border-brand-pink p-8 my-8" data-id="element-954">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-955">
                Did you know?
              </h3>
              <p className="text-neutral-700 text-lg leading-relaxed mb-4" data-id="element-956">
                Our corn fritters are vegetarian and gluten free! Becoming dairy
                free and vegan when taking away the crème fraiche.
              </p>
              <p className="text-neutral-900 text-xl font-medium" data-id="element-957">
                Yes, you read that correctly, our fritters are for EVERYONE!
              </p>
            </div>

            {/* Call to Action */}
            <div className="bg-brand-pink/5 p-8 my-12 text-center" data-id="element-958">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-959">
                Ready to Try Them?
              </h3>
              <p className="text-neutral-700 text-lg leading-relaxed mb-6" data-id="element-960">
                Stop into Restaurant Cuvee and enjoy our delicious corn
                fritters, some bubbles, exceptional service and a bloody good
                time.
              </p>
              <a href="/restaurant" className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group" data-id="element-961">
                Book Now
                <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-962" />
              </a>
            </div>

            {/* Back to Blog */}
            <div className="mt-12" data-id="element-963">
              <a href="/blog" className="inline-flex items-center gap-2 text-brand-pink hover:text-brand-pink/80 transition-colors font-medium" data-id="element-964">
                ← Back to News & Events
              </a>
            </div>
          </article>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-965" />
    </div>;
}